import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var ManagementCompanyRelatedData =
/*#__PURE__*/
function (_BaseData) {
  _inherits(ManagementCompanyRelatedData, _BaseData);

  function ManagementCompanyRelatedData(controller) {
    _classCallCheck(this, ManagementCompanyRelatedData);

    return _possibleConstructorReturn(this, _getPrototypeOf(ManagementCompanyRelatedData).call(this, controller));
  }

  _createClass(ManagementCompanyRelatedData, [{
    key: "GetByManagementCompanyId",
    value: function () {
      var _GetByManagementCompanyId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(managamentCompanyId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("api/".concat(this._controller, "/GetByManagementCompanyId/").concat(managamentCompanyId)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function GetByManagementCompanyId(_x) {
        return _GetByManagementCompanyId.apply(this, arguments);
      }

      return GetByManagementCompanyId;
    }()
  }]);

  return ManagementCompanyRelatedData;
}(BaseData);

export default ManagementCompanyRelatedData;